import { Project, DataFilter } from "interfaces";

import * as flowConfig from "./config";

export interface SalesEffectivenessProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: {
    [flowConfig.INPUT_DATA]: string;
    [flowConfig.AUGMENTED_FILE]: string;
  };
  meta_data: {
    [flowConfig.SUCCESS_COLUMN_KEY]: string;
    [flowConfig.SUCCESS_DEFINITION_KEY]: DataFilter.Filter[];
    [flowConfig.IS_APP_KEY]?: boolean;
    [flowConfig.MODELS_FOR_APP_KEY]?: { pred: string; clusters: string };
  };
  workspaces: {
    key: string;
    workspace: string;
    meta_data: {
      key: string;
      "variable-mapping": {
        [flowConfig.TIME_VARIABLE_KEY]?: string;
        [flowConfig.GROUPING_VARIABLES_KEY]?: string[];
        [flowConfig.LABEL_VARIABLES_KEY]?: string[];
        [flowConfig.ENTITY_VARIABLES_KEY]?: string[];
      };
    };
  }[];
}

export const projectIsSalesEffectiveness = (
  project: Project
): project is SalesEffectivenessProject =>
  project.flow === flowConfig.FLOW_NAME;

export type ModelAnnotationsInterface = {
  url: string;
  [flowConfig.RUN_ID]: string;
  [flowConfig.CREATED_BY]: string;
  [flowConfig.TIME_STAMP]: number;
};
